module.exports = "/images/kannada.svg?b664a084620d5590bd24f2d6457ce510";